import React, { createContext, useContext } from 'react'

export type ChampionsServerSideSelectionContextValue = {
  totalCount: number
  selectedCount: number
  selectingAll: boolean
  listLoading: boolean
  onSelectAllMatching: () => void
  onClearSelection: () => void
}

const ChampionsServerSideSelectionContext = createContext<ChampionsServerSideSelectionContextValue | null>(null)

export const ChampionsServerSideSelectionProvider = ChampionsServerSideSelectionContext.Provider

export const useChampionsServerSideSelectionContext = () => {
  const value = useContext(ChampionsServerSideSelectionContext)
  if (!value) {
    throw new Error('useChampionsServerSideSelectionContext requires ChampionsServerSideSelectionProvider')
  }
  return value
}
